module.exports = __webpack_public_path__ + "static/img/faq-3.7e1c7cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/faq-3.png
// module id = ujTM
// module chunks = 4